/* auren-blog.js - auto Table of Contents for article pages
   Scans H2 headings in the article body, generates anchor ids,
   and renders a Table of Contents box. */
(function () {
  'use strict';

  var content = document.querySelector('.auren-article__content');
  var toc = document.getElementById('auren-toc');
  if (!content || !toc) return;

  var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
  if (headings.length < 2) return; // only meaningful with 2+ sections

  function slugify(text) {
    var slug = text.trim().toLowerCase().replace(/\s+/g, '-');
    slug = slug.replace(/[^\p{L}\p{N}-]/gu, '').replace(/-{2,}/g, '-').replace(/^-|-$/g, '');
    return slug || 'section';
  }

  var used = {};
  headings.forEach(function (h) {
    if (!h.id) {
      var base = slugify(h.textContent);
      var id = base;
      var n = 2;
      while (used[id] || document.getElementById(id)) {
        id = base + '-' + n;
        n += 1;
      }
      used[id] = true;
      h.id = id;
    }
  });

  var list = document.createElement('ul');
  headings.forEach(function (h) {
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent;
    li.appendChild(a);
    list.appendChild(li);
  });
  toc.appendChild(list);
  toc.hidden = false;

  var links = Array.prototype.slice.call(toc.querySelectorAll('a'));

  function setActive(id) {
    links.forEach(function (a) {
      a.classList.toggle('is-active', a.getAttribute('href') === '#' + id);
    });
  }

  toc.addEventListener('click', function (e) {
    var a = e.target.closest('a');
    if (!a) return;
    var target = document.getElementById(a.getAttribute('href').slice(1));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.pushState(null, '', '#' + target.id);
      setActive(target.id);
    }
  });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    headings.forEach(function (h) {
      observer.observe(h);
    });
  }
})();
